import { getData } from "@/utils/fetch";
import debounce from "debounce-promise";
import { defineStore } from "pinia";

let debouncedFetch = debounce(getData, 500);

export const usePostOrderStore = defineStore({
  id: "postorder",
  state: () => ({
    postOrders: {},
    countByDate: {},
  }),
  getters: {
    getDataOrder(state) {
      return state.postOrders.data;
    },
  },
  actions: {
    async getAllPostOrder(params) {
      this.postOrders = { loading: true };

      const dataparams = {
        limit: params?.limit || 50,
        offset: params?.offset || 0,
        order: params?.order || "id",
        ordertype: params?.ordertype || "ASC",
        status: params?.status,
        q: params?.q,
      };

      try {
        const result = await debouncedFetch("post_order", dataparams);
        this.postOrders = { ...result.data };
      } catch (error) {
        console.log(error);
        this.postOrders = { error };
      }
    },
    async getCountByDate(params) {
      this.countByDate = { loading: true };

      const dataparams = {
        year: params?.year,
        month: params?.month,
      };

      try {
        const result = await debouncedFetch(
          "post_order/count/bydate",
          dataparams
        );
        this.countByDate = { ...result.data };
      } catch (error) {
        console.log(error);
        this.countByDate = { error };
      }
    },
  },
});
